import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96cb7fe2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home",
  "data-bs-theme": "light"
}
const _hoisted_2 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-container" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "jobWrapper"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Create new Job from Job Template", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("p", null, " This is a predefined blueprint for a job that is expected to be repeated. Creating a new job from a job template will keep a link to the original template, which helps in maintaining a standard process and makes job creation more efficient. ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Job Template Details", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "jobTemplateType" }, [
    /*#__PURE__*/_createTextVNode("Job Template Type"),
    /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*"),
    /*#__PURE__*/_createTextVNode(" : ")
  ])
], -1))
const _hoisted_15 = { class: "col" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select a template", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select a job template to view details.", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Error: Unable to load job template.", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "row my-1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Job Template Name: ", -1))
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Job Template Description: ", -1))
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Job Template Part Reference: ", -1))
const _hoisted_33 = { class: "col" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Job Details", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = { class: "input-group mb-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_40 = { class: "input-group mb-3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Description"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_42 = { class: "input-group mb-3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Priority "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Priority", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Low", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Medium", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "High", -1))
const _hoisted_48 = [
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Tasks", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Task Template Details : ", -1))
const _hoisted_54 = { class: "row my-1" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "taskTemplateType" }, [
    /*#__PURE__*/_createTextVNode("Task Template Type"),
    /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*"),
    /*#__PURE__*/_createTextVNode(": ")
  ])
], -1))
const _hoisted_56 = { class: "col" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Select a task template to view details.", -1))
const _hoisted_58 = ["value"]
const _hoisted_59 = {
  key: 0,
  class: "row"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select a task template to view details.", -1))
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { key: 2 }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Error: Unable to load task template.", -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { key: 3 }
const _hoisted_66 = { class: "row my-1" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Name: ", -1))
const _hoisted_68 = { class: "col" }
const _hoisted_69 = { class: "row my-1" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Description: ", -1))
const _hoisted_71 = { class: "col" }
const _hoisted_72 = { class: "row my-1" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Work Center: ", -1))
const _hoisted_74 = { class: "col" }
const _hoisted_75 = { class: "row my-1" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 my-1" }, "Template Cost Center: ", -1))
const _hoisted_77 = { class: "col" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Task Details", -1))
const _hoisted_82 = { class: "input-group mb-3" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Task Name"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_84 = ["onUpdate:modelValue"]
const _hoisted_85 = { class: "input-group mb-3" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Task Description"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_87 = ["onUpdate:modelValue"]
const _hoisted_88 = { class: "input-group mb-3" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Employee "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_90 = ["onUpdate:modelValue"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select an Employee", -1))
const _hoisted_92 = ["value"]
const _hoisted_93 = { class: "input-group mb-3" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-3 input-group-text" }, [
  /*#__PURE__*/_createTextVNode("Priority "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_95 = ["onUpdate:modelValue"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select Priority", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Low", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Medium", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "High", -1))
const _hoisted_100 = [
  _hoisted_96,
  _hoisted_97,
  _hoisted_98,
  _hoisted_99
]
const _hoisted_101 = { class: "input-group mb-3" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "col-3 input-group-text",
  for: "expectedStartDate"
}, [
  /*#__PURE__*/_createTextVNode("Expected Start"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_103 = ["onUpdate:modelValue"]
const _hoisted_104 = { class: "input-group mb-3" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "col-3 input-group-text",
  for: "expectedConclusionDate"
}, [
  /*#__PURE__*/_createTextVNode("Expected Conclusion "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-asterisk" }, "*")
], -1))
const _hoisted_106 = ["onUpdate:modelValue"]
const _hoisted_107 = ["onClick"]
const _hoisted_108 = ["disabled"]
const _hoisted_109 = {
  key: 4,
  class: "alert alert-danger"
}

import { fetchAllJobTemplates, fetchAllTaskTemplates, postToUrl } from '@/api/api';
import { Job, JobTemplate, Task, TaskTemplate } from '@/types/Ops';
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useEmployeeStore } from '@/stores/UserEmployee';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateJobFromTemplate',
  setup(__props) {

const route = useRoute();
const isCreatingTask = ref(false);
const jobTemplateId = ref(parseInt(route.params.templateId as string));
const employeeStore = useEmployeeStore();
const allJobTemplates = ref<JobTemplate[]>([]);
const selectedJobTemplateId = ref(null);
const allTaskTemplates = ref<TaskTemplate[]>([]);
const selectedTaskTemplateId = ref(null);
const errorMsg = ref('');


const job = ref<Job>({
  id: 0,
  name: '',
  description: '',
  build_order_reference: "",
  tasks: [],
  work_center: undefined,
  priority: 2,
  created_by: employeeStore.currentUser?.id,
});

const jobTemplate = ref<JobTemplate>({
  id: 0,
  name: '',
  description: '',
  part_reference: '',
  value: undefined,
  task_templates: [],
  work_center: 0
});

const tasks = ref<Task[]>([
  {
    id: 0,
    name: '',
    description: '',
    job: 0,
    employees: null,
    assignedEmployee: null,
    expected_start: '',
    expected_concluded: '',
    priority: 2,
  }
]);

const taskTemplate = ref<TaskTemplate>({
  id: 0,
  name: '',
  description: '',
  work_center: null,
  cost_center: null,
  job_template: 0,
  job_template_order: 0
});

const clearErrorMsg = () => {
  errorMsg.value = '';
};

watch(() => route.params, (nextParam, lastParam) => {
  jobTemplateId.value = parseInt(nextParam.templateId as string);
});


const filteredEmployees = computed(() => {
  return employeeStore.employees?.map(employee => {
    let rolePrefix;
    if (employee.user.is_superuser) {
      rolePrefix = "AD"; // Admin
    } else if (employee.user.is_staff) {
      rolePrefix = "MA"; // Manager
    } else {
      rolePrefix = "EM"; // Employee
    }
    const displayName = `${rolePrefix} - ${employee.user.full_name}`;
    return {
      ...employee,
      rolePrefix,
      displayName,
    };
  }) || [];
});

onMounted(async () => {
  try {
    allJobTemplates.value = await fetchAllJobTemplates();
    allTaskTemplates.value = await fetchAllTaskTemplates();
    await employeeStore.fetch();
  } catch (error) {
    console.error("Error fetching job templates:", error);
  }
});

const displayedJobTemplate = computed(() => {
  return selectedJobTemplateId.value
    ? jobTemplate.value
    : {
      name: '',
      description: '',
      part_reference: ''
    };
});

const displayedTaskTemplate = computed(() => {
  return selectedTaskTemplateId.value
    ? taskTemplate.value
    : {
      name: '',
      description: '',
      work_center: null,
      cost_center: null,
    };
});

watch(selectedJobTemplateId, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    updateDisplayedJobTemplate();
  }
});

watch(selectedTaskTemplateId, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    updateDisplayedTaskTemplate();
  }
});

const updateDisplayedJobTemplate = () => {
  const selectedTemplate = allJobTemplates.value.find(jt => jt.id === selectedJobTemplateId.value);
  if (selectedTemplate) {
    jobTemplate.value = selectedTemplate;
  }
};

const updateDisplayedTaskTemplate = () => {
  const selectedTemplate = allTaskTemplates.value.find(t => t.id === selectedTaskTemplateId.value);
  if (selectedTemplate) {
    taskTemplate.value = selectedTemplate;
  }
};

const addTask = () => {
  tasks.value.push({
    id: 0,
    name: '',
    description: '',
    employees: null,
    assignedEmployee: null,
    expected_start: '',
    expected_concluded: '',
    priority: 2,
  });
};


const removeTask = (index: number) => {
  tasks.value.splice(index, 1);
};

const resetTask = () => {
  tasks.value = [
    {
      id: 0,
      name: '',
      description: '',
      employees: null,
      value: '',
      work_center: null,
      cost_center: null,
      job: 0,
      started: undefined,
      started_by: 0,
      concluded: undefined,
      concluded_by: 0,
      successful: false,
      conclusion_notes: '',
      events: [],
      perpetual: false,
      task_template: 0,
      job_order: 0,
      task: undefined,
      completed: '',
      expected_start: '',
      expected_concluded: ''
    }
  ];
};


const isFormValid = computed(() => {
  if (!job.value.name.trim() || !job.value.description.trim()) {
    return false;
  }
  return tasks.value.every(task =>
    (task.name?.trim() || '') &&
    (task.description?.trim() || '') &&
    (task.expected_start?.trim() || '') &&
    task.assignedEmployee &&
    selectedTaskTemplateId.value
  );
});

const createJob = async () => {
  if (!isFormValid.value) {
    errorMsg.value = 'Please fill out all required fields for the job and each task.';
    return;
  }
  isCreatingTask.value = true;
  try {
    // console.log("Sending job data:", job.value);
    const jobResponse = await postToUrl(`/ops/api/template_to_job/${selectedJobTemplateId.value}/`, job.value);
    // console.log("Job creation response:", jobResponse);
    const jobId = jobResponse.id;
    // console.log("the job id is : ", jobId);
    for (const task of tasks.value) {
      if (!task.name && !task.description) {
        continue;
      }
      const taskPayload = {
        name: task.name,
        description: task.description,
        job: jobId,
        task_template: selectedTaskTemplateId.value,
        employees: task.assignedEmployee ? [task.assignedEmployee] : [],
        expected_start: task.expected_start,
        expected_concluded: task.expected_concluded,
        created_by: employeeStore.currentUser?.id,
        priority: task.priority,
      };
      // console.log('Task Payload:', taskPayload);
      await postToUrl(`/ops/api/create-task/${selectedTaskTemplateId.value}/`, taskPayload);
    }
    alert("Job and tasks have been successfully created.");
  } catch (error) {
    alert("Error occurred while creating job and tasks.");
  } finally {
    isCreatingTask.value = false;
    resetTask();
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isCreatingTask.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(" Creating Jobs and Tasks... "),
          _hoisted_3,
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    (job.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, [
              _withDirectives(_createElementVNode("select", {
                id: "jobTemplateType",
                class: "form-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedJobTemplateId).value = $event)),
                onChange: updateDisplayedJobTemplate,
                onInput: clearErrorMsg,
                required: ""
              }, [
                _hoisted_16,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allJobTemplates.value, (jt) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: jt.id,
                    value: jt.id
                  }, _toDisplayString(jt.name), 9, _hoisted_17))
                }), 128))
              ], 544), [
                [_vModelSelect, selectedJobTemplateId.value]
              ]),
              (!selectedJobTemplateId.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                : _createCommentVNode("", true)
            ])
          ]),
          (!jobTemplate.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("span", _hoisted_27, _toDisplayString(displayedJobTemplate.value.name), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("span", _hoisted_30, _toDisplayString(displayedJobTemplate.value.description), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("span", _hoisted_33, _toDisplayString(displayedJobTemplate.value.part_reference), 1)
                ])
              ])),
          _hoisted_34,
          _hoisted_35,
          _hoisted_36,
          _hoisted_37,
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((job.value.name) = $event)),
              type: "text",
              required: ""
            }, null, 512), [
              [_vModelText, job.value.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((job.value.description) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, job.value.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((job.value.priority) = $event)),
              class: "form-select",
              required: ""
            }, _hoisted_48, 512), [
              [_vModelSelect, job.value.priority]
            ])
          ]),
          _hoisted_49,
          _hoisted_50,
          _hoisted_51,
          _hoisted_52,
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("span", _hoisted_56, [
              _withDirectives(_createElementVNode("select", {
                id: "taskTemplateType",
                class: "form-select",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedTaskTemplateId).value = $event)),
                onChange: updateDisplayedTaskTemplate,
                required: ""
              }, [
                _hoisted_57,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allTaskTemplates.value, (tmpl) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: tmpl.id,
                    value: tmpl.id
                  }, _toDisplayString(tmpl.name), 9, _hoisted_58))
                }), 128))
              ], 544), [
                [_vModelSelect, selectedTaskTemplateId.value]
              ]),
              (!selectedTaskTemplateId.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_61))
                : _createCommentVNode("", true)
            ])
          ]),
          (!taskTemplate.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
            : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createElementVNode("span", _hoisted_68, _toDisplayString(displayedTaskTemplate.value.name), 1)
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _hoisted_70,
                  _createElementVNode("span", _hoisted_71, _toDisplayString(displayedTaskTemplate.value.description), 1)
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("span", _hoisted_74, _toDisplayString(displayedTaskTemplate.value.work_center ? displayedTaskTemplate.value.work_center.name : 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _hoisted_76,
                  _createElementVNode("span", _hoisted_77, _toDisplayString(displayedTaskTemplate.value.cost_center ? displayedTaskTemplate.value.cost_center.name : 'N/A'), 1)
                ]),
                _hoisted_78,
                _hoisted_79,
                _hoisted_80,
                _hoisted_81,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tasks.value, (task, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("h3", null, "Task " + _toDisplayString(index + 1), 1),
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control task-name-input",
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((task.name) = $event),
                        required: ""
                      }, null, 8, _hoisted_84), [
                        [_vModelText, task.name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _hoisted_86,
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control task-description-input",
                        "onUpdate:modelValue": ($event: any) => ((task.description) = $event),
                        required: ""
                      }, null, 8, _hoisted_87), [
                        [_vModelText, task.description]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      _hoisted_89,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((task.assignedEmployee) = $event),
                        class: "form-select",
                        required: ""
                      }, [
                        _hoisted_91,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEmployees.value, (employee) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: employee.id,
                            value: employee.id
                          }, _toDisplayString(employee.displayName), 9, _hoisted_92))
                        }), 128))
                      ], 8, _hoisted_90), [
                        [_vModelSelect, task.assignedEmployee]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _hoisted_94,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": ($event: any) => ((task.priority) = $event),
                        class: "form-select",
                        required: ""
                      }, _hoisted_100, 8, _hoisted_95), [
                        [_vModelSelect, task.priority]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_101, [
                      _hoisted_102,
                      _withDirectives(_createElementVNode("input", {
                        id: "expectedStartDate",
                        "onUpdate:modelValue": ($event: any) => ((task.expected_start) = $event),
                        type: "date",
                        class: "form-control",
                        required: ""
                      }, null, 8, _hoisted_103), [
                        [_vModelText, task.expected_start]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _hoisted_105,
                      _withDirectives(_createElementVNode("input", {
                        id: "expectedConclusionDate",
                        "onUpdate:modelValue": ($event: any) => ((task.expected_concluded) = $event),
                        type: "date",
                        class: "form-control",
                        required: ""
                      }, null, 8, _hoisted_106), [
                        [_vModelText, task.expected_concluded]
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-danger remove-task-btn",
                      onClick: ($event: any) => (removeTask(index))
                    }, "Remove Task", 8, _hoisted_107)
                  ]))
                }), 128))
              ])),
          _createElementVNode("button", {
            class: "btn btn-info add-task-btn",
            onClick: addTask
          }, "Add Task"),
          _createElementVNode("button", {
            class: "btn btn-primary create-job-btn",
            onClick: createJob,
            disabled: !isFormValid.value
          }, "Create Job", 8, _hoisted_108),
          (errorMsg.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_109, _toDisplayString(errorMsg.value), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})